export const Domain = `https://article-center.foxitreader.cn`;
export const FoxitwareDomain = `https://www.foxitsoftware.cn`;
// 软文自动生成
export const AutoGenerateDomain = import.meta.env.DEV
  ? "http://localhost:3123"
  : `http://18.142.74.110:3123`;
